import { Badge, Button, Tooltip } from "@jhool-io/fe-components";
import {
    formatDate,
    makeStringFirstLetterCapital,
} from "../../../../utils/helpers";
import { useFetchClientTags } from "../../hooks/clients.queries";
import { CLIENT_TAG_DETAILS } from "../../helpers/clients.helpers";
import { IClientTag } from "../../types/clients.types";

interface ClientTagBadgesProps {
    clientId: string;
    badgeClassName?: string;
}

export default function ClientTagBadges({
    clientId,
    badgeClassName,
}: ClientTagBadgesProps) {
    const clientTags = useFetchClientTags(clientId, Boolean(clientId));

    const getTagTooltip = (tag: IClientTag) => {
        const { description } = CLIENT_TAG_DETAILS[tag.tag_key];
        if (!tag.added_by_name || !tag.added_at) return description;
        return `${description} Added by ${
            tag.added_by_name
        } in ${makeStringFirstLetterCapital(tag.origin_system)}, ${formatDate(
            tag.added_at
        )}.`;
    };

    return (
        <>
            {(clientTags.data?.data || []).map((tag) => (
                <Tooltip key={tag.tag_key} content={getTagTooltip(tag)}>
                    <Button variant="normal" size="auto">
                        <Badge
                            content={
                                <span className="normal-case">
                                    {CLIENT_TAG_DETAILS[tag.tag_key].label}
                                </span>
                            }
                            type="neutral"
                            className={badgeClassName}
                        />
                    </Button>
                </Tooltip>
            ))}
        </>
    );
}
